<template>
  <div class="select-card">
    <div class="select-card-top">
      <div>产品分类</div>
      <div style="flex: 1">
        <div class="select-card-bottom">
          <div class="select-card-bottom-left">
            <!-- 产品分类 -->
            <el-cascader
              collapse-tags
              v-model="selectClass"
              :options="goodsType"
              :props="{ multiple: true, label: 'name', value: 'typeId' }"
              placeholder="请选择产品线"
              size="small"
              style="min-width: 120px"
            >
              <template #default="{ data }">
                <span>{{ data.name }}</span>
              </template>
            </el-cascader>
          </div>
          <div class="select-card-bottom-left" style="margin-left: 10px">
            <!-- 数据维度 -->
            <el-cascader
              collapse-tags
              v-model="select_data_tree"
              :options="data_tree"
              :props="{
                multiple: true,
                label: 'deptName',
                value: 'deptIdOrOaAccount',
                checkStrictly: true,
              }"
              placeholder="请选择组织架构"
              size="small"
              style="min-width: 120px"
            >
              <template #default="{ data }">
                <span>{{ data.deptName }}</span>
              </template>
            </el-cascader>
          </div>
          <div class="select-card-bottom-left" style="margin-left: 20px">
            <el-button type="primary" size="mini" @click="querySelect_line()"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <ul class="tabs-con">
        <li
          v-for="(i, index) in tabs"
          :key="index"
          :class="tabsIndex == i.type ? 'li-active' : ''"
          @click="tabClick(index)"
        >
          {{ i.name }}
        </li>
      </ul>
    </div>

    <div class="select-card-bottom">
      <ChartLine2
        v-if="tabsIndex == 3 && isFlag"
        :id="2"
        :tissueComparison="tissueComparison"
        :key="random"
      />
      <Bar
        v-if="tabsIndex == 2 && isFlag"
        :tissueComparison="tissueComparison"
        :id="2"
        :key="random"
      />
      <LineView
        v-if="tabsIndex == 1 && isFlag"
        :tissueComparison="tissueComparison"
        :id="2"
        :key="random"
      />
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import ChartLine2 from "./chart_line_2.vue";
import Bar from "./bar";
import LineView from "./lineview";
import get_jg_list from "@/utils/jg";
import { mapGetters } from "vuex";
export default {
  components: {
    ChartLine2,
    Bar,
    LineView,
  },
  props: ["chartType", "date"],
  computed: {
    // ...mapGetters(["incomeCompare_pro"]),
  },
  data() {
    return {
      random: 0,
      dateParam: {},
      doctorIds: [],
      doctors: [],
      cascaderProps: {
        multiple: true,
        label: "regionName",
        value: "regionCode",
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.lazyLoad,
      },
      tabs: [
        {
          name: "柱状图",
          type: 1,
        },
        {
          name: "分布图",
          type: 2,
        },
        {
          name: "趋势图",
          type: 3,
        },
      ],
      tabsIndex: 1,
      select_data_tree: [], // 选中的数据维度权限
      data_tree: [], // 数据维度树
      goodsType: [], // 产品类目列表
      selectClass: [], // 选中的类目
      isLoading: false,
      isFlag: "",
    };
  },
  created() {
    this.startTime = this.date.startTime;
    this.endTime = this.date.endTime;
    this.select_data_tree = [];
    this.selectClass = [];
    this.doctorIds = [];
    this.querySelect_line();
    // console.log(this.incomeCompare_pro)
    this.init();
  },
  methods: {
    lazyLoad(node, resolve) {
      console.log("lazyLoad", node);
      this.getData(node, resolve);
    },
    async getData(node, resolve) {
      let that = this;
      let { level, value } = node;
      console.log(node);
      let params = {
        levelType: parseInt(level + 1),
        regionCode: value,
        type: 1,
      };
      console.log(params);
      if (!node.data) {
        console.log("hdjshdjshdhjsdhds");
        let test = [];
        await this.axios
          .post("HospitalOrDoctor", params)
          .then((result) => {
            if (result.retCode == "200") {
              test = result.data;
              setTimeout(() => {
                const nodes = Array.from(test).map((item) => ({
                  value: item.regionCode,
                  label: `${item.regionName}`,
                  leaf: level >= 4,
                  // level
                }));
                resolve([...nodes]);
              }, 500);
            } else {
              this.$message.error(result.msg);
            }
          })
          .catch(() => {
            this.isLoading = false;
            // this.$store.dispatch("app/setLoading", false);
          });
      } else {
        let test = [];
        await this.axios
          .post("HospitalOrDoctor", params)
          .then((result) => {
            if (result.retCode == "200") {
              test = result.data;
              console.log(test, "test");
              setTimeout(() => {
                const nodes = Array.from(test).map((item) => {
                  return {
                    regionCode: item.regionCode,
                    regionName: `${item.regionName}`,
                    leaf: level >= 4,
                    // level
                  };
                });
                resolve(nodes);
                console.log(node.children, "eeee");
              }, 500);
            } else {
              this.$message.error(result.msg);
            }
          })
          .catch(() => {
            this.isLoading = false;
            // this.$store.dispatch("app/setLoading", false);
          });
      }
    },
    async init() {
      let { data_tree, goodsType, doctors } = await get_jg_list.get_jg_list(2);
      this.data_tree = data_tree;
      this.goodsType = goodsType;
      this.doctors = doctors;
      console.log(goodsType);
      // console.log(this.data_tree);
      console.log("产品分类-对比");
    },
    tabClick(val) {
      // console.log(val);
      this.tabsIndex = val + 1;
    },
    // 根据日期判断是月的第几周

    // 查询数据
    querySelect_line(type) {
      //type:1 组织架构 2:产品线
      this.isLoading = true;
      // this.$store.dispatch("app/setLoading", true);
      let params = {},
        url = "SALEGROSSPROFIT_PRODUCTLINECOST";
      let teams = [],
        departOneList = [],
        departTwoList = [],
        departThreeList = [];

      let jgData = [teams, departOneList, departTwoList, departThreeList];
      let productLinesData = [];
      // console.log(this.select_data_tree, data);
      if (this.select_data_tree.length > 0) {
        this.select_data_tree.forEach((element) => {
          element.forEach((child, c_index) => {
            jgData[c_index].push(child);
          });
        });
      }
      if (this.selectClass.length > 0) {
        this.selectClass.forEach((element) => {
          element.forEach((child, c_index) => {
            if (c_index == 0) {
              productLinesData.push(child);
            }
          });
        });
      }
      console.log(jgData);
      params = {
        departOneList: jgData[1].length > 0 ? [...new Set(jgData[1])] : [],
        departThreeList: jgData[2].length > 0 ? [...new Set(jgData[2])] : [],
        departTwoList: jgData[3].length > 0 ? [...new Set(jgData[3])] : [],
        startMonth: parseInt(this.startTime),
        productLines:
          productLinesData.length > 0 ? JSON.stringify(productLinesData) : [],
        endMonth: parseInt(this.endTime),
        teams: jgData[0].length > 0 ? [...new Set(jgData[0])] : [],
      };

      // 数据请求
      this.axios
        .post(url, params)
        .then((result) => {
          console.log("对比分析产品-查询返回", result);
          if (result.retCode == "200") {
            this.tissueComparison = result.data;
            this.random = Math.random();
            this.isLoading = false;
            this.isFlag = true;
            
          } else {
            this.$message.error(result.msg);
          }
          // this.$store.dispatch("app/setLoading", false);
        })
        .catch(() => {
          this.isLoading = false;
          // this.$store.dispatch("app/setLoading", false);
        });
    },
    formatDate(number) {
      var date = new Date(number);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return YY + MM + DD;
    },
  },
};
</script>

<style>
@media (max-width: 1440px) {
  /* 小于1440 */
  .week-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .week-input2 {
    margin-right: 0 !important;
    margin-top: 10px;
  }
  .text-btn2 {
    margin-left: 8px !important;
  }
  .text-btn3 {
    margin-left: 8px !important;
    margin-right: 0px !important;
  }
  .select-day {
    margin-left: 12px !important;
  }
  .class-list {
    margin-left: 8px !important;
  }
}
</style>

<style scoped lang="scss">
.select-card {
  background: #ffffff;

  border-bottom-left-radius: none;
  border-bottom-right-radius: none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  width: 100%;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  margin-top: 24px;
  .select-card-top {
    color: #262626;
    font-weight: bold;
    font-size: 16px;
    padding: 13px 24px 13px 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .tabs-con {
      min-width: 200px;
      display: flex;
      flex-direction: row;
      li {
        flex: 1;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-left: 16px;
      }
      .li-active {
        color: #00b54b;
        border-bottom: 2px solid #00b54b;
        text-align: center;
         font-weight: 700;
      }
    }
    .question {
      width: 18px;
      height: 18px;
      margin-left: 5px;
    }
    .question:hover {
      cursor: pointer;
    }
  }
  .select-card-bottom {
    padding: 8px 24px 8px 24px;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    align-items: center;
    .select-card-bottom-left {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      .class-list {
        margin-left: 24px;
        width: 200px;
      }
    }
    .select-card-bottom-right {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>